import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { DeleteConfirmationModal, SectionTitle } from "@components";
import { TableColumn } from "./TableColumn";
import { useState } from "react";

function SelectedProductsTable({
  selectedAssets,
  handleRequestedAmount,
  handleProductRemove,
}: any) {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [itemId, setItemId] = useState<number>();

  const { t } = useTranslation();

  const closeConfirmationModel = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    closeConfirmationModel();
    handleProductRemove(itemId as number);
  };

  return (
    <>
      <SectionTitle label="INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TITLE" />
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          onClose={closeConfirmationModel}
          action={deleteAction}
        />
      )}
      <Table
        columns={
          TableColumn(
            t,
            handleRequestedAmount,
            setIsConfirmationModalOpen,
            setItemId,
          ) as any
        }
        rows={selectedAssets}
        // remove={{
        //   customIcon: <IconTrash01 size={24} fill="danger" />,
        //   onClick: (id) => {
        //     setIsConfirmationModalOpen(true);
        //     setItemId(id as number);
        //   },
        // }}
      />
    </>
  );
}

export default SelectedProductsTable;
